import { Skeleton } from 'apps/shared/scripts/components';

import {
  cardContainerClassName,
  cardPreviewCardClassName,
  cardPreviewClassName,
  containerClassName,
  deviceClassName,
  heroClassName,
} from './styles';

const CardPreviewLoading = () => {
  return (
    <div className={cardPreviewClassName}>
      <div className={containerClassName}>
        <div className={deviceClassName}>
          <div className={cardPreviewCardClassName}>
            <div className={cardContainerClassName}>
              <div className={heroClassName}>
                <Skeleton
                  borderRadius={100}
                  lineHeight={1.4}
                  height={8}
                  count={2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CardPreviewLoading.displayName = 'CardPreviewLoading';

export default CardPreviewLoading;
